import comp from "./VerifyPhoneOTP";
export default comp;
